// extracted by mini-css-extract-plugin
export default {"cls1":"ResearchInterestTags-cls1__b29da58305e8001e82d2","cls2":"ResearchInterestTags-cls2___0c26415e89743c29b9b ResearchInterestTags-cls1__b29da58305e8001e82d2"};